import { Modal } from '@la/ds-ui-components';
import { Product } from '@la/types';
import { useRegistrationAddOns } from 'redux/hooks/useRegistrationAddOns';
import { RequiredAddOnCard } from 'domains/MemberRegistration/AddOnCard/RequiredAddOnCard';
import styles from './AddOnsModal.module.scss';

export type AddOnsModalProps = {
  closeModal: () => void;
  open: boolean;
  modalTitle?: string;
  registrationType?: string;
};

/* AddOnsModal */
export default function AddOnsModal({
  closeModal,
  modalTitle = 'Required add-ons',
  open,
  registrationType,
}: Readonly<AddOnsModalProps>) {
  const { getRequiredAddOnsByType } = useRegistrationAddOns();
  const addOnsData =
    registrationType === 'player'
      ? getRequiredAddOnsByType('player')
      : getRequiredAddOnsByType('staff');

  return (
    <Modal
      backgroundColor={'var(--blue-grey-25)'}
      onOpenChange={closeModal}
      open={open}
      size="small"
      title={modalTitle}
    >
      <AddOnItems addOnsData={addOnsData} />
    </Modal>
  );
}

export function AddOnItems({
  addOnsData,
}: Readonly<{ addOnsData: Product[] }>) {
  return (
    <div className={styles.addOnItems}>
      {addOnsData.map((addOnData, idx) => (
        <RequiredAddOnCard
          addOnData={addOnData}
          cardDisplayType="truncated"
          key={`${addOnData.name}-${addOnData.id}`}
        />
      ))}
    </div>
  );
}
